import AOS from "aos";
document.addEventListener("DOMContentLoaded", () => {
  AOS.init({
    offset: 50,
  });
});
